module.exports = "pegasus/assets/theme5/small/7.jpg";